import * as Encoding from 'encoding-japanese';
import { getApplicationText } from '../types/common/application-type';
const moment = require('moment-timezone');

/**
 * CDEのCSVを作ってUploadしているところ参考
 */
export const CsvHeader = [
  '申請種別',
  '物件No.',
  '郵便番号',
  '住所',
  '番地',
  '集合住宅名・棟号数',
  '氏名（姓）',
  '氏名（名）',
  'フリガナ（姓）',
  'フリガナ（名）',
  '電話番号',
  'メールアドレス',
  '電気利用有無',
  'ガス利用有無',
  'お支払い方法',
  '電気申し込みプラン',
  '電気オプション割引',
  '電気の使用開始日',
  'ガスのお申し込みプラン',
  'ガスのオプション割引',
  'ガスの使用開始日',
  'ガスの使用開始日(時間帯)',
  '開栓の立ち合い者',
  '立ち合い者の氏名',
  '当日の連絡先',
  '退去日',
  '変更フラグ',
  'キャンセルフラグ',
  '紐付ID'
];

export function returnCsvValue(content: string | undefined | number): string {
  if (content === '' || content === undefined || content === null) {
    return '';
  } else {
    return `${content}`;
  }
}

export function CsvExportGenerator(records: any): any {
  return records.map(record => {
    return [
      returnCsvValue(getApplicationText(record.applicationCategory)),
      returnCsvValue(record.propertyServiceCode),
      returnCsvValue(record.postCode),
      returnCsvValue(record.prefecture + record.city),
      returnCsvValue(record.afterCity),
      returnCsvValue(record.address2),
      returnCsvValue(record.customerLastName),
      returnCsvValue(record.customerFirstName),
      returnCsvValue(record.customerLastNameKana),
      returnCsvValue(record.customerFirstNameKana),
      returnCsvValue(record.customerPhoneNumber),
      returnCsvValue(record.customerEmail),
      returnCsvValue(record.hasElectricContractText),
      returnCsvValue(getUseGasPlanSelectionText[record.useGasPlanSelection]),
      returnCsvValue(record.paymentMethodSelectionText),
      returnCsvValue(record.electricityBasePlanSelectionText),
      returnCsvValue(
        record.useGasPlanSelection === '0' ? 'ガスセット割引' : ''
      ),
      returnCsvValue(record.electricityStartDate),
      returnCsvValue(getGasBasePlanSelectionText[record.gasBasePlanSelection]),
      returnCsvValue(
        record.gasBasePlanSelection === '0' ? '電気セット割引' : ''
      ),
      returnCsvValue(record.gasStartDate),
      returnCsvValue(record.gasStartTimeSelectionText),
      returnCsvValue(record.witnessGasStartText),
      returnCsvValue(record.witnessNameGasStart),
      returnCsvValue(record.phoneNumberForGasStart),
      returnCsvValue(record.serviceStopDate),
      returnCsvValue(record.isModifiedInSameDay === true ? '更新' : ''),
      returnCsvValue(record.isCanceledInSameDay === true ? 'キャンセル' : ''),
      returnCsvValue(record.linkageId)
    ];
  });
}

export function generateFileName(
  targetService: string,
  csvType: string,
  startDate: string,
  endDate: string
): string {
  const start = moment(startDate).format('YYYYMMDD');
  const end = moment(endDate).format('YYYYMMDD');
  // 同一日付の場合は「YYYYMMDD」、異なる場合は「YYYYMMDD_YYYYMMDD」
  const dateSetting = moment(end).isSame(moment(start))
    ? `${end}`
    : `${start}_${end}`;
  // ファイル名の定義
  return `${targetService}_${csvType.toUpperCase()}_${dateSetting}.csv`;
}

export function convertToBlob(csvRows: string[][]): Blob {
  const csvContent = [
    CsvHeader.join(','),
    ...csvRows.map(row => row.join(','))
  ].join('\r\n');
  const unicodeList = [];
  for (let i = 0; i < csvContent.length; i += 1) {
    // @ts-ignore
    unicodeList.push(csvContent.charCodeAt(i));
  }
  // 変換処理の実施
  const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
  const uInt8List = new Uint8Array(shiftJisCodeList);
  return new Blob([uInt8List], { type: 'text/csv' });
}

// ガス利用有無
const getUseGasPlanSelectionText = {
  '0': '利用あり',
  '1': '利用なし'
};

// ガスのお申し込みプラン
const getGasBasePlanSelectionText = {
  '0': 'ベーシックガス',
  '1': 'ゆかぽかガス'
};
